import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgBellIconSecondary from './svgs/BellIconSecondary.js';
import SvgBellIcon from './svgs/BellIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var bellIcon = (props => useIcon(SvgBellIcon, SvgBellIconSecondary, props));

export { bellIcon as default };
